export const AddressModel = {
  address_line1: "",
  address_line2: "",
  city: "",
  postal_code: "",
  country_id: "",
};

export class AddressDecorator {
  constructor(address) {
    this.address = address;
  }

  get get_address() {
    const address = [
      this.address.address_line1,
      this.address.address_line2,
      this.address.city,
      this.address.postal_code,
      this.address.country_id,
    ];

    const info = [];
    Object.entries(address).forEach((entity) => {
      info.push(entity[1]);
    });

    return info.join(", ");
  }

  toRequest() {
    return {
      address_line1: this.address.address_line1,
      address_line2: this.address.address_line2,
      city: this.address.city,
      postal_code: this.address.postal_code,
      country_id: this.address.country_id,
    };
  }

  toStorageString() {
    return JSON.stringify({
      address_line1: this.address.address_line1,
      address_line2: this.address.address_line2,
      city: this.address.city,
      postal_code:
        this.address.postal_code === null ? 0 : this.address.postal_code,
      country_id:
        this.address.country_id === null ? 0 : this.address.country_id,
    });
  }
}
